const state = () => {
  return {
    import_templates: [],
    import_template: {},
    required_attributes: [],
    import_configurations: [],
    import_source_credentials: [],

    //tracktor api
    import_validated_data: [],
    import_validated_data_settings: [],
    tracktor_api_projects: [],
    tracktor_api_vehicles: [],
    tracktor_api_sync_status: null,
  }
}

export default state;
